import React from 'react'

import { ReactComponent as PersonIcon } from '@src/assets/escher/icons/person.svg';
import urls from '@src/urls';
import Link from '@styled/Elements/Link';

export default function UserDropdown() {
  return (
        <Link to={urls.authed.profile()}>
      <PersonIcon />
    </Link>
  )
}
